<template>
  <div class="principal-stepper-movil">
    <div class="accordion-item">
      <h2 class="accordion-header" id="headingTwo">
        <button
          class="accordion-button collapsed boton-acordeon"
          type="button"
          data-bs-toggle="collapse"
          data-bs-target="#collapseTwo"
          aria-expanded="false"
          aria-controls="collapseTwo"
        >
          Completado {{ pasos.filter(paso => paso.completado).length }} de
          {{ pasos.length }}
        </button>
      </h2>
      <div
        id="collapseTwo"
        class="accordion-collapse collapse"
        aria-labelledby="headingTwo"
        data-bs-parent="#accordionExample"
      >
        <div class="accordion-body">
          <ul class="progressbar-i">
            <li v-for="(paso, index) in pasos" :key="index">
              <div
                :class="
                  paso.completado ? 'circulo' : 'circulo circulo-inactivo'
                "
              ></div>
              <label
                :class="paso.completado ? 'label-activdo' : 'label-inactivo'"
              >
                {{ paso.nombre }}
              </label>
            </li>
          </ul>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "StepperIntegracionMovil",
  props: {
    pasos: Array
  },
  data() {
    return {};
  },
  mounted() {}
};
</script>

<style scoped lang="scss">
$color-primario: #b8725a;
$poppins: "Poppins";
$gris-deshabilitado: #bcbcbc;

.principal-stepper-movil {
  display: none;
}

@media all and (max-width: 767px) {
  .principal-stepper-movil {
    display: block;
  }
}

/*estilo linea */
.boton-acordeon {
  border-radius: 0px !important;
  background-color: $color-primario;
  border: 1px solid $color-primario;
  color: white;
  font-family: Poppins;
  font-weight: bold;
  height: 45px;
}
.accordion-button:focus {
  z-index: 3;
  border: none !important;
  outline: 0;
  box-shadow: none !important;
}

.accordion-button:not(.collapsed) {
  color: white !important;
  background-color: $color-primario !important;
  box-shadow: none !important;
}
.accordion-button:after {
  flex-shrink: 0;
  width: 1.25rem;
  height: 1.25rem;
  margin-left: auto;
  content: "";
  background-image: url("../../../../../assets/iconos-embajadores/arrowhite.png") !important;
  background-repeat: no-repeat;
  background-size: 20px 12px, calc(0.75em + 0.375rem) calc(0.75em + 0.375rem) !important;
  transition: transform 0.2s ease-in-out;
}
.accordion-button:not(.collapsed):after {
  background-image: url("../../../../../assets/iconos-embajadores/arrowhite.png") !important;
  transform: rotate(-180deg);
}
.progressbar-i {
  counter-reset: step;
  display: flex;
  flex-direction: column;
}
.progressbar-i .label-activo {
  text-transform: capitalize;
  font-family: $poppins;
  font-weight: 500;
  color: #696158;
  font-size: 14px;
}
.progressbar-i .label-inactivo {
  text-transform: capitalize;
  font-family: $poppins;
  font-weight: 700;
  color: $gris-deshabilitado;
  font-size: 14px;
}
.progressbar-i li {
  text-align: initial;
  list-style: none;
  height: 75px;
}
.progressbar-i .circulo {
  display: flex;
  list-style-type: none;
  width: 20%;
  font-size: 16px;
  position: relative;
  text-align: center;
  text-transform: capitalize;
  font-family: $poppins;
  font-weight: 700;
  color: $color-primario;
  float: left;
}

.progressbar-i li .circulo:before {
  content: "\f00c";
  font-family: "Font Awesome 5 Free";
  font-size: 13px;
  border: 2px solid #28893b;
  background-color: #28893b;
  color: white;
  width: 27px;
  height: 27px;
  display: block;
  margin: 0 auto 10px auto;
  border-radius: 50%;
  line-height: 27px;
  text-align: center;
  font-weight: bold;
  z-index: 1;
}

.progressbar-i .circulo:after {
  content: "";
  position: absolute;
  width: 0;
  height: 220%;
  border: 1px solid #707070;
  background-color: #ada8a3;
  top: 0;
  left: 48%;
}

.progressbar-i .circulo.circulo-inactivo:before {
  border: 5px solid $gris-deshabilitado;
  background-color: white;
  width: 24px;
  height: 24px;
  content: "";
}
.progressbar-i .circulo.circulo-inactivo:after {
  border: 1px solid $gris-deshabilitado;
}
</style>
